module.exports = __webpack_public_path__ + "static/media/simon1.02def529.jpg";